import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Box, Typography, Tabs, Tab, Button } from "@mui/material";
import axios from "axios";
import { API_URL } from "../components/Constant";
import Colors from "../components/Colors";

function CreatorLanding() {
  const [creatorDetails, setCreatorDetails] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [creatorTempDetails, setCreatorTempDetails] = useState([]);

  function formattedDate(publishingTime) {
    return new Date(publishingTime).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/questions_under_development`,
          {
            CreatorTocken: localStorage.getItem("CreatorTocken"),
          },
        );
        console.log("response.data", response.data);
        setCreatorTempDetails(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/select_creator_all_game_by_tocken`,
          {
            CreatorTocken: localStorage.getItem("CreatorTocken"),
          },
        );
        console.log("select_creator_all_game", response.data);
        setCreatorDetails(response.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCreatorDetails([]);
      }
    };
    fetchGameData();
    const intervalId = setInterval(fetchGameData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Ensure creatorDetails is not undefined before filtering and remove duplicate games
  const filterUniqueGames = (games) => {
    const seen = new Set();
    return games.filter((game) => {
      if (seen.has(game.game_id)) {
        return false;
      }
      seen.add(game.game_id);
      return true;
    });
  };

  const ReleaseSoon = filterUniqueGames(
    creatorDetails.filter((game) => game.game_status === "Launching Soon"),
  );
  const releasedGames = filterUniqueGames(
    creatorDetails.filter((game) => game.game_status !== "Launching Soon"),
  );
  const filteredCreatorTempDetails = filterUniqueGames(creatorTempDetails);

  // Handle Tab Change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Handle Game Click
  const handleGameClick = async (gameId, activeTab) => {
    localStorage.setItem("gameId", gameId);
    if (activeTab === 0) {
      window.location.href = "/crossword-creator";
    }
    if (activeTab === 1) {
      window.location.href = "/release-soon";
    }
    if (activeTab === 2) {
      window.location.href = "/creator-play-game";
    }
  };

  const handleCreateNewGame = async () => {
    localStorage.removeItem("gameId");
    localStorage.removeItem("category");
    localStorage.removeItem("RapidGame");
    window.location.href = "/theme";
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        background: Colors.bgColor,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          background: Colors.Tidesbg,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            maxWidth: "90%",
            flexDirection: "column",
            gap: "16px",
            width: "100%",
            height: "100vh",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: "100%",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              onClick={handleCreateNewGame}
              sx={{
                background: Colors.button1,
                color: Colors.button1font,
                width: "250px",
                border: "1px solid",
                borderColor: Colors.button1Border,
                marginTop: "2%",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "12px",
                transition: "background 0.3s, transform 0.3s",
                "&:hover": {
                  background: Colors.button1,
                  transform: "scale(1.05)",
                },
                "&:active": {
                  background: Colors.button1,
                },
              }}
            >
              Create new game
            </Button>
          </Box>

          {/* Tabs with customized style */}
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            centered
            sx={{
              ".MuiTabs-indicator": {
                display: "none",
              },
              display: "flex",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Tab
              label="Under Development"
              sx={{
                fontSize: "14px",
                color: Colors.tab1color,
                textDecoration: "none",
                textUnderlineOffset: "5px",
                "&:hover": {
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
                "&.Mui-selected": {
                  color: Colors.tab1color,
                  fontWeight: "bold",
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
              }}
            />
            <Tab
              label="Release Soon"
              sx={{
                fontSize: "14px",
                color: Colors.tab2color,
                textDecoration: "none",
                textUnderlineOffset: "5px",
                "&:hover": {
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
                "&.Mui-selected": {
                  color: Colors.tab2color,
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
              }}
            />
            <Tab
              label="Released"
              sx={{
                fontSize: "14px",
                color: Colors.tab1color,
                textDecoration: "none",
                textUnderlineOffset: "5px",
                "&:hover": {
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
                "&.Mui-selected": {
                  color: Colors.tab1color,
                  fontWeight: "bold",
                  textDecoration: "underline",
                  textUnderlineOffset: "5px",
                  textDecorationThickness: "1.5px",
                },
              }}
            />
          </Tabs>

          {/* Display games based on active tab */}
          <Box sx={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            {activeTab === 0
              ? filteredCreatorTempDetails.map((game, index) => (
                  <Box
                    key={index}
                    onClick={() => handleGameClick(game.game_id, activeTab)}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      height: "50px",
                      background: "#f0f0f0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography
                      sx={{
                        color: Colors.Tidesfont,
                        fontSize: "18px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {game.game_id}
                      <span
                        style={{
                          fontWeight: 400,
                          lineHeight: "24px",
                          color: Colors.Tidesfont,
                          textAlign: "center",
                          fontFamily: "Roboto",
                          maxWidth: "600px",
                        }}
                      >
                        {" "}
                        ({game.theme})
                      </span>
                    </Typography>
                  </Box>
                ))
              : (activeTab === 1 ? ReleaseSoon : releasedGames).map((game) => (
                  <Box
                    key={game.game_id}
                    onClick={() => handleGameClick(game.game_id, activeTab)}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      padding: "20px",
                      height: "60px",
                      background: "#f0f0f0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      gap: "8px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <>
                      <Typography
                        sx={{
                          color: "#202f75",
                          fontSize: "18px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {game.game_id}
                        <span
                          style={{
                            fontWeight: 400,
                            lineHeight: "24px",
                            color: "#202f75",
                            textAlign: "center",
                            fontFamily: "Roboto",
                            maxWidth: "600px",
                          }}
                        >
                          {" "}
                          ({game.theme})
                        </span>
                      </Typography>{" "}
                    </>
                    {activeTab === 1 && (
                      <Typography
                        sx={{
                          color: "#202f75",
                          fontSize: "14px",
                          textAlign: "center",
                          fontWeight: 500,
                        }}
                      >
                        {formattedDate(game.publishing_time)}
                      </Typography>
                    )}
                  </Box>
                ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default CreatorLanding;
